import { useEffect, useState } from 'react';
import { generalStore } from '../stores/GeneralStore';
import { getRevenuePoolAssets } from '../api/stoApi';
import { Asset } from '../models';
import { apiErrorHandling } from '../api/apierrorhandling';
import { useTranslation } from 'react-i18next';

export const useRevenuePoolAssets = (reload: boolean, id?: string) => {
  const t = useTranslation();
  const [revenuePoolAssets, setRevenuePoolAssets] = useState<{ items: Asset[]; count: number }>({ items: [], count: 0 });
  const load = async () => {
    if (!id) return;
    try {
      generalStore.setIsLoading(true);
      const res = (await getRevenuePoolAssets(id))?.data;
      setRevenuePoolAssets(res.data);
    } catch (err) {
      apiErrorHandling(err, t('revenuePools.errors.loadPoolAssets'));
    } finally {
      generalStore.setIsLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [id, reload]);

  return revenuePoolAssets;
};
